import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IDashboardEntryItemUI from "../../../../models/IDashboardEntryItemUI";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import * as _ from "lodash-es";
import { OwIconButton } from "../../../shared/OwIconButton/OwIconButton";
import { NumericFormat } from "react-number-format";
import SupplierContext from "../../../../contexts/SupplierContext";
import OrderEntryService from "../../../../services/OrderEntryService";

type Props = {
    item: IDashboardEntryItemUI;
    updateItem: (item: IDashboardEntryItemUI) => void;
};

export const DashboardItemEntryQty = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [editMode, setEditMode] = useState<boolean>(false);
    const [qty, setQty] = useState<number>(props.item.qty);

    useEffect(() => {
        console.log("props.item.qty changed", props.item.qty);
        // if (props.item.qty !== qty) {
        //
        // }
        // setQty(props.item.qty);
    }, [props.item.qty]);

    const handleChange = (e: ChangeEvent<any>) => {
        let value = Number(e.target.value || 1);

        if (_.isNil(value) || _.isNaN(value)) {
            value = 1;
        }

        const precision = supplierModel?.qty_precision ?? 0;
        const multiplier = Math.pow(10, precision);
        value = Math.round(value * multiplier) / multiplier;

        // todo validate inventory is available.

        setQty(value);
    };

    const qtyStep = OrderEntryService.getQtyStepValue(supplierModel?.qty_precision, props.item.Catalog_Item?.unit_incr_qty);

    const saveChange = () => {
        setEditMode(false);

        const item: IDashboardEntryItemUI = {
            ...props.item,
            qty,
        };

        props.updateItem(item);
    };

    return (
        <div className={"DashboardItemEntryQty"}>
            {editMode ? (
                <div>
                    <OwFnInput fn={handleChange} name={"qty"} value={qty} type={"number"} step={qtyStep} />
                    <OwIconButton iconClass={"fas fa-check"} iconColorClass={"text-success"} fn={saveChange} />
                </div>
            ) : (
                <div onClick={() => setEditMode(true)}>
                    <u className={"pointer"}>
                        <NumericFormat
                            value={qty}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={supplierModel.qty_precision || 2}
                            fixedDecimalScale={true}
                        />
                    </u>
                </div>
            )}
        </div>
    );
};
